import { useEffect, useState } from 'react';
import { Alert } from '@salecycle/ui-component-library';
import { useValidationResults } from '../../../../../contexts/selectors/useValidationResults';
import { useTranslation } from 'react-i18next';
import { useWorkflowForm } from '../../../../../contexts/CampaignWorkflowFormContext';
const ValidationList = () => {
  const validationResults = useValidationResults();
  return (
    <ul>
      {validationResults.map((s, i) => (
        <li key={i}>{s.error}</li>
      ))}
    </ul>
  );
};
export const ValidationBanner = () => {
  const { t } = useTranslation('campaigns');
  const { state } = useWorkflowForm();
  const validationResults = state.validationResults;
  const validationType = state.validationType;
  const [isClosed, setIsClosed] = useState(false);
  // Reset closed state when new errors appear
  useEffect(() => {
    if (validationResults.length > 0) {
      setIsClosed(false);
    }
  }, [validationResults]);
  if (isClosed || validationResults.length === 0) {
    return null;
  }
  const headingKey =
    validationType === 'save'
      ? 'onsite.editor.workflow.validation.errorBannerHeadingSave'
      : 'onsite.editor.workflow.validation.errorBannerHeading';
  return (
    <Alert variant="error" heading={t(headingKey)} description={<ValidationList />} onClose={() => setIsClosed(true)} />
  );
};
